import { createLucideIcon } from 'lucide-react';

// Lines in brackets: a period, summed up. Drawn on lucide's grid so it takes the same stroke and size as its icons
// (picked in experiments/nav-icons, 2X).
const RecapIcon = createLucideIcon('recap', [
    ['path', { d: 'M8 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2', key: 'bracket-open' }],
    ['path', { d: 'M16 4h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2', key: 'bracket-close' }],
    ['path', { d: 'M8.5 9h7', key: 'line-1' }],
    ['path', { d: 'M8.5 12h7', key: 'line-2' }],
    ['path', { d: 'M8.5 15h4', key: 'line-3' }],
]);

export default RecapIcon;
